<template>
  <cbt-base-tabs :current-tab="currentTab" :tabs="tabs">
    <cbt-schedule v-if="currentTab === 'schedule'" />
    <cbt-report v-else-if="currentTab === 'report'" />
    <cbt-answer v-else-if="currentTab === 'answer'" />
    <cbt-export v-else-if="currentTab === 'export'" />
    <!-- Default to schedule tab for unknown tab values -->
    <cbt-schedule v-else />
  </cbt-base-tabs>
</template>

<script setup lang="ts">
  import {ITeacherCbtTab} from "@/consts/interfaces";

  withDefaults(
    defineProps<{
      currentTab?: ITeacherCbtTab["name"];
    }>(),
    {
      currentTab: "schedule"
    }
  )

  const tabs: ITeacherCbtTab[] = [
    { name: "schedule", label: "開始・終了・返却" },
    { name: "report", label: "集計・分析" },
    { name: "answer", label: "解答確認・修正" },
    { name: "export", label: "データ出力" }
  ];
</script>
